export { default as useGlobalModal } from './useGlobalModal';

export * from './GlobalModalProvider';
export * from './types';
